module.exports = __webpack_public_path__ + "static/media/cnbc.05b884f5.jpg";